import { MantineProvider } from '@mantine/core';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Orden importante: los tokens de marca antes que los estilos de Mantine, para que el tema pueda
// referenciar las custom properties, y los nuestros al final.
import './styles/tribbu-tokens.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import './styles/app.css';

import { App } from './App';
import { theme } from './theme';

const root = document.getElementById('root');
if (!root) throw new Error('Falta #root en index.html');

createRoot(root).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <App />
    </MantineProvider>
  </StrictMode>,
);
